import { FC } from 'react';
import { type Quiz } from '@teachur/http-client';
import { ExamActionCard } from './ExamActionCard';
import { useExamProgress } from '@new/features/courses/hooks/useExamProgress';

const NEXT_ATTEMPT_INCREMENT = 1;

interface RetryExamCardProps {
  attempts: Quiz[];
}

export const RetryExamCard: FC<RetryExamCardProps> = ({ attempts }) => {
  const hasAttempts = attempts.length > 0;
  const { remainingQuestions } = useExamProgress(attempts);

  const attemptNumber = attempts.length + NEXT_ATTEMPT_INCREMENT;
  const shouldShow = hasAttempts && remainingQuestions > 0;

  if (!shouldShow) return null;

  return (
    <ExamActionCard
      title={`Ready for attempt ${attemptNumber}?`}
      description={`Retake the exam to answer ${remainingQuestions} more questions correctly.`}
      buttonText={`Retry ${remainingQuestions} questions`}
      backgroundColor="bg-(--primary-O200)"
    />
  );
};
